import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { Table, View, Text, InfiniteScroll, TableColumnOpcoes, Icon } from '@components';
import { getLogs, reset } from '@ducks/conectoresLogs';
import { formatDateTimeS, Notification } from '@utils';

export default function TableLogs() {
  const dispatch = useDispatch();
  const { id } = useParams();
  const history = useHistory();

  const logs = useSelector(({ conectoresLogs }) => conectoresLogs.get('logs').toArray());
  const loadingLogs = useSelector(({ conectoresLogs }) => conectoresLogs.get('loadingLogs'));
  const hasMoreLogs = useSelector(({ conectoresLogs }) => conectoresLogs.get('hasMoreLogs'));
  const xCurrentPage = useSelector(({ conectoresLogs }) => conectoresLogs.get('xCurrentPage'));

  const handleSearch = () => {
    if (!loadingLogs) {
      dispatch(getLogs(id, xCurrentPage + 1));
    }
  };

  const handleInfiniteOnLoad = () => {
    if (!hasMoreLogs) {
      Notification.warning('Todos os logs foram retornados');
    } else {
      handleSearch();
    }
  };

  const handleReset = () => {
    dispatch(reset());
  };

  useEffect(() => {
    handleReset();
  }, []);

  useEffect(() => {
    if (xCurrentPage === 0) handleSearch();
  }, [xCurrentPage]);

  const columns = [
    {
      title: 'Data',
      dataIndex: 'dt',
      key: 'dt',
      render: (text) => (
        <View>
          <Text>{formatDateTimeS(text)}</Text>
        </View>
      ),
    },
    {
      title: 'Tipo',
      dataIndex: 'tp',
      key: 'tp',
    },
    {
      title: 'Versão',
      dataIndex: 'versao',
      key: 'versao',
      render: (text) => (
        <View>
          <Text>v{text}</Text>
        </View>
      ),
    },
    {
      title: 'Opções',
      dataIndex: 'id',
      key: 'options',
      align: 'right',
      width: '7%',
      render: (text, item) => (
        <TableColumnOpcoes>
          <Icon.Detail action={() => history.push(`/conectores/configuracao/${item.idConfiguracao}/log/${item.id}`)} />
        </TableColumnOpcoes>
      ),
    },
  ];

  return (
    <InfiniteScroll dataLength={logs.length} next={handleInfiniteOnLoad} hasMore={loadingLogs && hasMoreLogs}>
      <Table rowKey='id' columns={columns} dataSource={logs} loading={loadingLogs} hidePagination />
    </InfiniteScroll>
  );
}
